import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipuriDateComponent } from './tipuri-date.component';
import { AddTipuriDateComponent } from './add-tipuri-date/add-tipuri-date.component';
import { EditTipuriDateComponent } from './edit-tipuri-date/edit-tipuri-date.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [
        TipuriDateComponent,
        AddTipuriDateComponent,
        EditTipuriDateComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [
        TipuriDateComponent
    ],
})
export class TipuriDateModule { }
